import React from 'react';

import myobLogo from '../../assets/images/myob-logo.png';

import './BlockPage.scss';

export const BlockPage: React.FC = () => (
  <>
    <div
      data-testid='block-page-top-bar'
      className='block-page-top-bar'
      style={{ height: '10px' }}
    />
    <div className='block-page-container'>
      <div className='block-page-header'>
        <img
          className='block-page-header-myob-logo'
          src={myobLogo}
          alt='myob-logo'
        />
      </div>
      <div className='block-page-main'>
        <div className='block-page-right-container'>
          <h3 className='block-page-right-container-tagline'>
            Sorry, we&apos;re having trouble processing some online purchases right now
          </h3>

          <div className='block-page-right-container-bottom-text-container'>
            <p>
              If your purchase fails and you&apos;re unable to access your software,
              we&apos;ll be in touch via email shortly to help
              set up your account.
            </p>
            <p>
              We&apos;re working to resolve this as quickly as possible.
              We apologise for any inconvenience and appreciate your
              patience.
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
);
